module.exports = __webpack_public_path__ + "img/fyt_p24.bd9e44eb.png";